(function($, window){
    var replaceTextOnly = function(html, searchString, replacement) {
        var rx = new RegExp('(?![^<]+>)' + searchString, 'gi');
        return html.replace(rx, replacement);
    }

    var staticContentTranslation = function(selector, staticContent, dynamicTranslation) {
        var html = $(selector).html();
        var translation = {
            selector: selector,
            text: '',
        }

        if(html && typeof html === 'string') translation.text = replaceTextOnly(html, staticContent, dynamicTranslation);

        return translation
    }

    $(document).ready(function() {

        $('.Esc-returns-container form #step_three .Esc-returns-Form__RefundMethod label').each(function() {
            if(typeof $(this).attr('for') == 'undefined') {
                var forAttribute = $(this).find('input').attr('value');
                $(this).attr("data-value", forAttribute);
            }
        });

        var translations = [
                {
                selector: '.Esc-returns-container > .mb20 > p',
                text: "To start the return process for your order, please enter your email address or phone number and the order number below.",
            },
            {
                selector: '.Esc-returns-container .Esc-returns-form label[for="email"]',
                text: "Email Address / Phone Number:",
            },
            {
                selector: '.Esc-returns-container .Esc-returns-form label[for="order_number"]',
                text: "Order Number:",
            },
            {
                selector: '.Esc-returns-container .Esc-returns-form [type="submit"]',
                text: "Start",
            },
            {
                selector: '.Esc-returns-container .alert.alert-danger',
                text: "<strong>Oops!</strong><span id='errorText'>We couldn't find your order. Please check if you entered the right email address / phone number and order number.</span>",
            },
            {
                selector: '.Esc-returns-container form > div > h4',
                text: "Submit a new return request",
            },
            {
                selector: '.Esc-returns-container form #step_one h4',
                text: "Select the quantity of the products you want to return",
            },
            {
                selector: '.Esc-returns-container form #step_three .form-group > label',
                text: "Refund method",
            },
            {
                selector: '.Esc-returns-container form #next_step',
                text: "Next Step",
            },
            {
                selector: '.Esc-returns-container form #step_two h4',
                text: "Choose the reason for return for each item",
            },
            {
                selector: '.Esc-returns-container form #step_three h4',
                text: "Translation missing: en.returns.finish",
            },
            {
                selector: '.Esc-returns-container form label[for="notification_email"]',
                text: "Notification Email",
            },
            {
                selector: '.Esc-returns-container form #passwordHelpBlock',
                text: "This email is needed if we send a return label, and all notifications regarding the status of your return.",
            },
            {
                selector: '.Esc-returns-container .alert.alert-success',
                text: "The return request has been created. Please wait for approval.",
            }

        ]

        translations.push(staticContentTranslation('.Esc-returns-container > h3', 'Order', "Order"))
        translations.push(staticContentTranslation('.Esc-returns-container > p', 'Ordered by', "Ordered by"))
        translations.push(staticContentTranslation('.Esc-returns-container label[for="notes"]', 'Notes', "Notes"))

        // Step aware translations
        if ($('#step_three').length) {
            translations.push({
                selector: '.Esc-returns-container form #next_step',
                text: "Submit"
            });
            translations.push(staticContentTranslation('.Esc-returns-container form #step_three .Esc-returns-Form__RefundMethod label[data-value="Refund"]','Refund',"Refund"));
            translations.push(staticContentTranslation('.Esc-returns-container form #step_three .Esc-returns-Form__RefundMethod label[data-value="Exchange"]','Exchange',"Exchange"));
            translations.push(staticContentTranslation('.Esc-returns-container form #step_three .Esc-returns-Form__RefundMethod label[data-value="Credit"]','Credit',"Credit"))
        }


        translations.map(function(trans) {
            if(trans.text.indexOf('translation missing') !== -1) trans.text = '';

            $(trans.selector).html(trans.text)
        });

        $('.Esc-returns-container').addClass('return-text--loaded');
    });
})(jQuery, window);